/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import { LogLevel, Configuration, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;


export const b2cPolicyDev = {
    names: {
        signUpSignIn: 'b2c_1a_signup_signin_aad'
    },
    authorities: {
        signUpSignIn: {
        authority: 'https://designautomatorb2c.b2clogin.com/designautomatorb2c.onmicrosoft.com/b2c_1a_signup_signin_aad',
        },
        logout: {
            authority: "https://login.microsoftonline.com/common"
        }
    },
  authorityDomain: 'designautomatorb2c.b2clogin.com'
};

export const b2cPolicyConfigDev: Configuration = {
    auth: {
        clientId: 'fac38b52-606d-40d5-ac38-67c2070370db', // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicyDev.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
        knownAuthorities: [b2cPolicyDev.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: '/auth', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
        postLogoutRedirectUri: '/', // Points to window.location.origin by default.
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
    },
    system: {
        /**
         * Below you can configure MSAL.js logs. For more information, visit:
         * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
         */
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false
        }
    }
};

export function getMsalConfigDev(): Configuration {
    return Object.assign({}, b2cPolicyDev, b2cPolicyConfigDev);
}




export const b2cPolicyProd = {
    names: {
        signUpSignIn: 'b2c_1a_signup_signin_aad'
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://designautomatorb2c.b2clogin.com/designautomatorb2c.onmicrosoft.com/b2c_1a_signup_signin_aad',
        },
        logout: {
            authority: "https://login.microsoftonline.com/common"
        }
    },
    authorityDomain: 'designautomatorb2c.b2clogin.com'
};

export const b2cPolicyConfigProd: Configuration = {
    auth: {
        clientId: 'fac38b52-606d-40d5-ac38-67c2070370db', // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicyProd.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
        knownAuthorities: [b2cPolicyProd.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: '/auth', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
        postLogoutRedirectUri: '/', // Points to window.location.origin by default.
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
    },
    system: {
        /**
         * Below you can configure MSAL.js logs. For more information, visit:
         * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
         */
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false
        }
    }
};

export function getMsalConfigProd(): Configuration {
    return Object.assign({}, b2cPolicyProd, b2cPolicyConfigProd);
}

/**
* Scopes you add here will be prompted for user consent during sign-in.
* By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
* For more information about OIDC scopes, visit:
* https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
*/
export const loginRequest = {
    scopes: []
};
